/**
 * BaseView
 */

// sun added container for the overlay(23 line, 58 line)
define(function(require, exports, module) {
    'use strict';
    const $ = require('j');
    const _ = require('underscore');
    var BaseView = require('common/base.view');

    require('common/touch.events');

    /**
     * @class
     * @name BaseView
     * @augments Backbone.View
     */
    module.exports = BaseView.extend(
        /** @lends BaseView */
        {

            renderOverlay: function(appendSelector = '#application') {
                var isNew = true;
                var $overlay = $('.fn-overlay');

                $overlay = $(_.filter($overlay, function(overlay) {
                    return !overlay.classList.contains('overlay__hide');
                }, this));

                // select old overlay, of exist
                if ($overlay.length) {
                    isNew = false;
                } else {
                    $overlay = $(this.tmpl('common.overlay'));
                }

                $overlay.off('.overlay');

                this.hideKeyboard();
                $overlay.on('resize.overlay', function() {
                    $overlay && $overlay.css({
                        height: '100%',
                        width: '100%'
                    });
                });

                $overlay.on('touchmove.overlay', function(event) {
                    if (document.body.classList.contains('ios_11_fix')) { // TODO remove after fix IOS bug
                        return;
                    }
                    event.preventDefault();
                });

                // animations for new overlay
                if (isNew) {
                    $overlay
                        .appendTo(appendSelector)
                        .addClass('overlay__show');
                    $('body').addClass('overlaid');
                }

                this.options = this.options || {};
                if (!this.options.isModal) {
                    $overlay.on('tap.overlay', this.closeByOverlay.bind(this));
                }

                this.$overlay = $overlay;
            },
        });
    });
